export default function handleApiError(error) {
  if (!error.response) {
    return "Network error. Please check your connection.";
  }

  const { status, data } = error.response;

  if (status === 401) return "You are not authorized. Please login.";
  if (status === 400) return data.message || "Invalid request.";
  if (status === 500) return "Server error. Please try again later.";

  return "Something went wrong.";
}
